import React from 'react';
import { CompassIcon } from 'lucide-react';
import { SubscribeButton } from './SubscribeButton';
import { channel } from '../data/channel';
const navItems = [{
  href: '#latest',
  label: 'Нові'
}, {
  href: '#map',
  label: 'Мапа'
}, {
  href: '#top',
  label: 'Топ'
}, {
  href: '#playlists',
  label: 'Добірки'
}, {
  href: '#about',
  label: 'Про мене'
}];
export function SiteHeader() {
  return <header className="sticky top-0 z-50 border-b border-line bg-ink" data-id="element-136" data-mp="uxpjb3v9itby">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-6 px-5 md:px-8" data-id="element-137" data-mp="qwnfsaubbv46">
        <a href="#top-of-page" className="flex items-center gap-2.5" aria-label={`${channel.name} — на початок`} data-id="element-138" data-mp="14wf1yyuzght9">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-ember text-ember-ink" data-id="element-139" data-mp="zwsn6kziatic">
            <CompassIcon className="h-5 w-5" aria-hidden="true" data-id="element-140" data-mp="2gb28f68gc24y" />
          </span>
          <span className="font-display text-base font-semibold tracking-tight" data-id="element-141" data-mp="2bcr1b39jk5qf">{channel.name}</span>
        </a>

        <nav aria-label="Розділи" className="hidden md:block" data-id="element-142" data-mp="29kbspi7uaqq4">
          <ul className="flex items-center gap-8" data-id="element-143" data-mp="29m6e0xn0wkuq">
            {navItems.map(item => <li key={item.href} data-id="element-144" data-mp="2ekzrwr682dvf">
                <a href={item.href} className="text-sm font-semibold text-paper/80 transition-colors duration-150 hover:text-paper" data-id="element-145" data-mp="2jhgh7op5qya3">
                  {item.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <SubscribeButton data-id="element-146" data-mp="1vs5lilmnzu2t" />
      </div>
    </header>;
}